<script>
  import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
  export default {
    name: "crossTwoEditor",
    mixins: [componentEditorMixin],
    data() {
      return {
        directionList:[
          {
            name: '向上',
            value: 'top'
          },
          {
            name: '向下',
            value: 'bottom'
          },
          {
            name: '向左',
            value: 'left'
          },
          {
            name: '向右',
            value: 'right'
          },

        ],
        diameterList:[
          {
            name: '矩形',
            value: 'same'
          },
          {
            name: '梯形',
            value: 'different'
          }
        ],
        formList: [
          'CrossTwoForm',
        ],
        ruleList: [
          {
          }
        ]
      }
    },
    computed: {
      specificForms() {
        return (
          <div class="specificForms">
              <el-collapse-item class="specificForm" title="二通管道效果选项" name="2">
                <template slot="default">
                  <div class="specificForm">
                    <el-form id="CrossTwoForm" props={{model: this.newSettings}} ref="CrossTwoForm" label-style={this.formLabelStyle}>
                      <el-form-item label="管道颜色" prop="pipelineColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.pipelineColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"管道颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.pipelineColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="管道方向" prop="pipelineDirection" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.pipelineDirection,
                          type: 'radio',
                          radioList: this.directionList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"管道方向",
                          }}}{...{on: {
                            'input': val=>{
                              this.pipelineDirectionChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>

                      <el-form-item label="变径管道" prop="pipelineDiameter" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                            value: this.newSettings.pipelineDiameter,
                            type: 'radio',
                            radioList: this.diameterList,
                            varList: this.varList,
                            varJson: this.varJson,
                            showEditButton: true,
                            label:"变径管道",
                          }}}{...{on: {
                            'input': val=>{
                              this.pipelineDiameterChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </el-collapse-item>
          </div>
        )
      }
    },
    methods:{
      pipelineColorChange(val){
        if(this.newSettings.pipelineDirection === 'top'|| this.newSettings.pipelineDirection === 'bottom'){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'background': 'linear-gradient(to right, '+ val +', white,'+ val + ')',
          }
          this.newSettings.pipelineColor = val
        }
        if(this.newSettings.pipelineDirection === 'right'||this.newSettings.pipelineDirection === 'left'){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'background': 'linear-gradient(to bottom, '+ val +', white,'+ val + ')',
          }
          this.newSettings.pipelineColor = val
        }
      },
      pipelineDirectionChange(val){
        console.log('val=',val,'pipleDirec=',this.newSettings.pipelineDirection)
        if((val === 'top'|| val === 'bottom')&& this.newSettings.pipelineDiameter === 'same'&& (this.newSettings.pipelineDirection === 'top'|| this.newSettings.pipelineDirection === 'bottom')){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            'background': 'linear-gradient(to right, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }else if((val === 'top'|| val === 'bottom')&& this.newSettings.pipelineDiameter === 'same'&& (this.newSettings.pipelineDirection === 'right'|| this.newSettings.pipelineDirection === 'left')){
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            'background': 'linear-gradient(to right, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }
        else if((val === 'right'||val === 'left') && this.newSettings.pipelineDiameter === 'same' && (this.newSettings.pipelineDirection === 'right'|| this.newSettings.pipelineDirection === 'left')){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            'background': 'linear-gradient(to bottom, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }  else if((val === 'right'||val === 'left') && this.newSettings.pipelineDiameter === 'same' && (this.newSettings.pipelineDirection === 'top'|| this.newSettings.pipelineDirection === 'bottom')){
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            'background': 'linear-gradient(to bottom, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }else if(val === 'right'&& this.newSettings.pipelineDiameter === 'different' && (this.newSettings.pipelineDirection === 'right'|| this.newSettings.pipelineDirection === 'left')){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 25%, 100% 75%, 0 100%)',
            'background': 'linear-gradient(to bottom, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }else if(val === 'right'&& this.newSettings.pipelineDiameter === 'different' && (this.newSettings.pipelineDirection === 'top'|| this.newSettings.pipelineDirection === 'bottom')){
            let tempHeight = this.newSettings.width
            let tempWidth = this.newSettings.height
            this.handleUniversalChangeSize(tempWidth, 'width')
            this.handleUniversalChangeSize(tempHeight, 'height')
            this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 25%, 100% 75%, 0 100%)',
            'background': 'linear-gradient(to bottom, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }else if(val === 'left'&& this.newSettings.pipelineDiameter === 'different' && (this.newSettings.pipelineDirection === 'right'|| this.newSettings.pipelineDirection === 'left')){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 25%, 100% 0, 100% 100%, 0 75%)',
            'background': 'linear-gradient(to bottom, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }else if(val === 'left'&& this.newSettings.pipelineDiameter === 'different' && (this.newSettings.pipelineDirection === 'top'|| this.newSettings.pipelineDirection === 'bottom')){
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 25%, 100% 0, 100% 100%, 0 75%)',
            'background': 'linear-gradient(to bottom, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }else if(val === 'top'&& this.newSettings.pipelineDiameter === 'different' && (this.newSettings.pipelineDirection === 'top'|| this.newSettings.pipelineDirection === 'bottom')){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(25% 0, 75% 0, 100% 100%, 0 100%)',
            'background': 'linear-gradient(to right, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }else if(val === 'top'&& this.newSettings.pipelineDiameter === 'different' && (this.newSettings.pipelineDirection === 'right'|| this.newSettings.pipelineDirection === 'left')){
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(25% 0, 75% 0, 100% 100%, 0 100%)',
            'background': 'linear-gradient(to right, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }else if(val === 'bottom'&& this.newSettings.pipelineDiameter === 'different'&& (this.newSettings.pipelineDirection === 'top'|| this.newSettings.pipelineDirection === 'bottom')){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 0, 75% 100%, 25% 100%)',
            'background': 'linear-gradient(to right, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }else if(val === 'bottom'&& this.newSettings.pipelineDiameter === 'different'&& (this.newSettings.pipelineDirection === 'right'|| this.newSettings.pipelineDirection === 'left')){
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 0, 75% 100%, 25% 100%)',
            'background': 'linear-gradient(to right, '+ this.newSettings.pipelineColor +', white,'+ this.newSettings.pipelineColor + ')',
          }
          this.newSettings.pipelineDirection = val
        }
      },
      pipelineDiameterChange(val){
        if(val === 'same'){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
          }
          this.newSettings.pipelineDiameter = val
        } else if(this.newSettings.pipelineDirection === 'right'&& val === 'different'){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 25%, 100% 75%, 0 100%)',
          }
          this.newSettings.pipelineDiameter = val
        }else if(this.newSettings.pipelineDirection === 'left'&& val === 'different'){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 25%, 100% 0, 100% 100%, 0 75%)',
          }
          this.newSettings.pipelineDiameter = val
        }else if(this.newSettings.pipelineDirection === 'top'&& val === 'different'){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(25% 0, 75% 0, 100% 100%, 0 100%)',
          }
          this.newSettings.pipelineDiameter = val
        }else if(this.newSettings.pipelineDirection === 'bottom'&& val === 'different'){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'clip-path': 'polygon(0 0, 100% 0, 75% 100%, 25% 100%)',
          }
          this.newSettings.pipelineDiameter = val
        }
      }
    }
  }
</script>

<style lang="less">
  .crossTwoEditor {
    .singleSelect {
      height: 30px;
      line-height: 30px;
      width: 100%;
      border-radius: 5px;
      padding: 0 10px;
    }
  }
</style>

